import React, { useState, useEffect } from "react";
import Media from "react-media";
import { Button, Image, Container } from "react-bootstrap";
import OfflineEvent from "./OfflineEvent";
import OnlineEvent from "./OnlineEvent";
import { makeStyles } from "@material-ui/core";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AddNewEventVendor = (props) => {
  const classes = useStyles();
  //state
  const [selectedTab, setSelectedTab] = useState(
    props.subscriptionData &&
      props.subscriptionData.offline_event &&
      props.subscriptionData.offline_event.value
      ? 1
      : 2
  );
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };
  const [state, setState] = useState({
    country: "",
    restaurant: "",
    state: "",
    City: "",
  });
  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setSelectedTab(props.subscriptionData?.offline_event?.value ? 1 : 2);
  }, []);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="right-side-panel">
            <Media query="(max-width: 992px)">
              <RightSideNavigation
                // displayButton="addOffer"
                // leftText="vendorReview"
                backButtonLink="/event"
                // displayText="back"
              />
            </Media>
            <Media query="(min-width: 992px)">
              <RightSideNavigation
                // displayButton="addOffer"
                leftText="vendorReview"
                backButtonLink="/event"
                displayText="Back"
              />
            </Media>
            {/* <Container> */}
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add New Event</div>
              </div>
              <div className="f20-700 mb-4">Event Type</div>
              {/* .casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .event_management */}
              <div className="d-flex align-items-start">
                {props.subscriptionData?.offline_event?.value ? (
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion ${
                      selectedTab === 1 ? "active" : ""
                    }`}
                    onClick={(e) => handleTab(1)}
                  >
                    <Image
                      src={
                        selectedTab === 1
                          ? require("../../../../assets/images/UserManagement/offlineActiveOffer.svg")
                          : require("../../../../assets/images/UserManagement/offlineDeactiveOffer.svg")
                      }
                      alt="View"
                      title="View"
                      fluid
                      className="ml-3"
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Offline Event
                    </span>
                    <span className="w-100 f9-400 d-block">
                      (Note: Events are in a physical venue and you can even
                      accept RSVP)
                    </span>
                  </Button>
                ) : null}
                {props.subscriptionData?.online_event?.value ? (
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion ml-3 ${
                      selectedTab === 2 ? "active" : ""
                    }`}
                    onClick={(e) => handleTab(2)}
                  >
                    <Image
                      src={
                        selectedTab === 2
                          ? require("../../../../assets/images/UserManagement/onlineActiveOffer.svg")
                          : require("../../../../assets/images/UserManagement/onlineDeactiveOffer.svg")
                      }
                      alt="View"
                      title="View"
                      fluid
                      className="ml-3"
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Online Event
                    </span>
                    <span className="w-100 f9-400 d-block">
                      (Note: Events are online you need a link stored at the
                      time Event creation You can accept RSVP for the event)
                    </span>
                  </Button>
                ) : null}
              </div>
              <hr />
              {props.subscriptionData?.offline_event?.value
                ? selectedTab === 1 && <OfflineEvent />
                : null}
              {props.subscriptionData?.online_event?.value
                ? selectedTab === 2 && <OnlineEvent />
                : null}
            </div>
            {/* </Container> */}
          </div>
        </div>
        {/* </div> */}
      </div>
    </React.Fragment>
  );
};

AddNewEventVendor.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscriptionData:
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .event_management,
});

export default connect(mapStateToProps, null)(withRouter(AddNewEventVendor));
